import { Component, Input } from '@angular/core';
import { ClipboardIconComponent } from '@shared/src/lib/icons/clipboard-icon/clipboard-icon.component';
import { PetronasIconComponent } from '@shared/src/lib/icons/petronas-icon/petronas-icon.component';
import { SettingsIconComponent } from '@shared/src/lib/icons/settings-icon/settings-icon.component';
import { UserManagementIconComponent } from '@shared/src/lib/icons/user-management-icon/user-management-icon.component';
import { HistoricalMrIconComponent } from '@shared/src/lib/icons/historical-mr-icon/historical-mr-icon.component';

@Component({
  selector: 'lib-icon',
  standalone: true,
  imports: [
    PetronasIconComponent,
    ClipboardIconComponent,
    UserManagementIconComponent,
    SettingsIconComponent,
    HistoricalMrIconComponent,
  ],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css',
})
export class IconComponent {
  @Input() name: string;
}
